export const API_ENDPOINT = process.env.RAZZLE_API_ENDPOINT;

export const GOOGLE_API_KEY = process.env.RAZZLE_GOOGLE_API_KEY;

export const GOOGLE_MAPS_API_KEY = process.env.RAZZLE_GOOGLE_MAPS_API_KEY;

export const GOOGLE_RECAPTCHA_SITE_KEY = process.env.RAZZLE_GOOGLE_RECAPTCHA_SITE_KEY;

export const SENTRY_DSN = process.env.RAZZLE_SENTRY_DSN;

export const HIDE_TINYMCE = process.env.RAZZLE_HIDE_TINYMCE;
export const TINYMCE_SWITCH = process.env.RAZZLE_TINYMCE_SWITCH;

export const SHOW_EXTERNAL_BOOKINGS = process.env.RAZZLE_SHOW_EXTERNAL_BOOKINGS;
export const SHOW_CASE_HISTORY = process.env.RAZZLE_SHOW_CASE_HISTORY;
export const JOURNAL_API = process.env.RAZZLE_JOURNAL_API;
export const JOURNAL_DASHBOARD = process.env.RAZZLE_JOURNAL_DASHBOARD

export const DOMAINS = [
    {
        domen: 'https://dev.curoflow.se',
        api: 'https://devapi.curoflow.se',
        name: 'SE - DEV',
        country: 'sweden'
    },
    {
        domen: 'https://devdev.curoflow.se',
        api: 'https://devdevapi.curoflow.se',
        name: 'SE - DEVDEV',
        country: 'sweden'
    },
    {
        domen: 'https://test.curoflow.se',
        api: 'https://testapi.curoflow.se',
        name: 'SE - TEST',
        country: 'sweden'
    },
    {
        domen: 'https://tryme.curoflow.se',
        api: 'https://tryme-api.curoflow.se',
        name: 'SE - TRYME',
        country: 'sweden'
    },
    {
        domen: 'https://dashboard.curoflow.se',
        api: 'https://dashboardapi.curoflow.se',
        name: 'SE - DASHBOARD',
        country: 'sweden'
    },
    {
        domen: 'https://sandbox.curoflow.se',
        api: 'https://sandboxapi.curoflow.se',
        name: 'SE - SANDBOX',
        country: 'sweden'
    },
    {
        domen: 'https://test.curoflow.dk',
        api: 'https://testapi.curoflow.dk',
        name: 'DK - TEST',
        country: 'denmark'
    },
    {
        domen: 'https://tryme.curoflow.dk',
        api: 'https://tryme-api.curoflow.dk',
        name: 'DK - TRYME',
        country: 'denmark'
    },
    {
        domen: 'https://dashboard.curoflow.dk',
        api: 'https://dashboardproxy.curoflow.dk',
        name: 'DK - DASHBOARD',
        country: 'denmark'
    },
    {
        domen: 'https://test.curoflow.uk',
        api: 'https://testapi.curoflow.uk',
        name: 'UK - TEST',
        country: 'uk'
    },
    {
        domen: 'https://tryme.curoflow.uk',
        api: 'https://tryme-api.curoflow.uk',
        name: 'UK - TRYME',
        country: 'uk'
    },
    {
        domen: 'https://dashboard.curoflow.uk',
        api: 'https://dashboardproxy.curoflow.uk',
        name: 'UK - DASHBOARD',
        country: 'uk'
    },
    {
        domen: 'https://test.curoflow.ch',
        api: 'https://testapi.curoflow.ch',
        name: 'CH - TEST',
        country: 'ch'
    },
    {
        domen: 'https://tryme.curoflow.ch',
        api: 'https://tryme-api.curoflow.ch',
        name: 'CH - TRYME',
        country: 'ch'
    },
    {
        domen: 'https://dashboard.curoflow.ch',
        api: 'https://dashboardproxy.curoflow.ch',
        name: 'CH - DASHBOARD',
        country: 'ch'
    },
    {
        domen: 'https://test.curoflow.gr',
        api: 'https://testapi.curoflow.gr',
        name: 'GR - TEST',
        country: 'gr'
    },
    {
        domen: 'https://tryme.curoflow.gr',
        api: 'https://tryme-api.curoflow.gr',
        name: 'GR - TRYME',
        country: 'gr'
    },
    {
        domen: 'https://dashboard.curoflow.gr',
        api: 'https://dashboardproxy.curoflow.gr',
        name: 'GR - DASHBOARD',
        country: 'gr'
    },
    {
        domen: 'https://test.es.curoflow.com',
        api: 'https://test-api.es.curoflow.com',
        name: 'ES - TEST',
        country: 'es'
    },
    {
        domen: 'https://tryme.es.curoflow.com',
        api: 'https://tryme-api.es.curoflow.com',
        name: 'ES - TRYME',
        country: 'es'
    },
    {
        domen: 'https://dashboard.es.curoflow.com',
        api: 'https://dashboardproxy.es.curoflow.com',
        name: 'ES - DASHBOARD',
        country: 'es'
    },
    {
        domen: 'https://test.curoflow.ae',
        api: 'https://testapi.curoflow.ae',
        name: 'AE - TEST',
        country: 'ae'
    },
    {
        domen: 'https://tryme.curoflow.ae',
        api: 'https://trymeapi.curoflow.ae',
        name: 'AE - TRYME',
        country: 'ae'
    },
    {
        domen: 'https://dashboard.curoflow.ae',
        api: 'https://dashboardproxy.curoflow.ae',
        name: 'AE - DASHBOARD',
        country: 'ae'
    },
    {
        domen: 'https://test.curoflow.ro',
        api: 'https://testapi.curoflow.ro',
        name: 'RO - TEST',
        country: 'ro'
    },
    {
        domen: 'https://dashboard.curoflow.ro',
        api: 'https://dashboardproxy.curoflow.ro',
        name: 'RO - DASHBOARD',
        country: 'ro'
    }
]
export const CHILD_AGE_LIMIT = {
    denmark: 15,
    sweden: 13,
    uk: 18,
    es: 18,
    ch: 18,
    gr: 18,
    ae: 18,
    ro: 18,
}

export const getAgeLimit = (
    country,
    aliasOrId,
    exceptions,
) => {
    if (!exceptions || !Array.isArray(exceptions)) exceptions = getClinicsAgeLimitExceptions();
    if (exceptions && Array.isArray(exceptions) && exceptions.length > 0 && aliasOrId) {
        const exception = exceptions.find(obj => obj._id === aliasOrId || obj.alias === aliasOrId);
        if (exception && exception.ageLimit) return (+exception.ageLimit);
    }

    if (country && CHILD_AGE_LIMIT[country]) return CHILD_AGE_LIMIT[country];

    return 18;
}

export function getClinicsAgeLimitExceptions() {
    try {
        if (typeof window !== 'undefined') {
            const str = localStorage?.getItem?.('clinicsAgeLimitExceptions');
            if (str) {
                const arr = JSON.parse(str);
                if (arr && Array.isArray(arr)) return arr;
            }
        }
    } catch (err) { }

    return [];
}

export function translateAgeLimitMessage(
    message,
    lang,
    ageLimit,
    country,
    aliasOrId,
) {
    try {
        if (typeof message === 'string' && message && lang) {
            if (!ageLimit && country) {
                ageLimit = getAgeLimit(country, aliasOrId);
            }
            if (!ageLimit) ageLimit = 18;
            const translatedMessage = message.translate(lang).replace(/{AGE_LIMIT}/g, ageLimit).replace(/{AGE_LIMIT-1}/g, ageLimit - 1);
            return translatedMessage;
        }
    } catch (err) { }

    return message;
}
